import { render, staticRenderFns } from "./PatientBulkTransferFormBrandToDenzapineApprovalForm.vue?vue&type=template&id=0e0a2de4&scoped=true"
import script from "./PatientBulkTransferFormBrandToDenzapineApprovalForm.vue?vue&type=script&lang=js"
export * from "./PatientBulkTransferFormBrandToDenzapineApprovalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a2de4",
  null
  
)

export default component.exports